import React, { useState, useEffect } from "react";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState";
import useDebounceSearch from "../../../hooks/useDebounchSearch";
import HelperMetiers360 from "../../../services/HelpersMetiers360";
import { Alert, Button, Col, Row } from "react-bootstrap";
import Loader from "../../../components/widgets/Loader";
import CategoriesTableComponent from "../../../components/categories/CategoriesTableComponent";
import { useStoreActions, useStoreState } from "easy-peasy";
import CategoriesFormComponent, { submitCategoryForm } from "../../../components/categories/CategoryFormComponent";
import { useToast } from "../../../hooks/useToast";
import { useModal } from "../../../hooks/useModal";

const CategoriesPage = () => {
    const { allCategories, isFetchingAllCategories } = useCustomGetStoreState("categories");
    const categoriesSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("categories"));
    const { createCategory } = useStoreActions(actions => actions.categories);

    const toast = useToast();
    const { modalComponent, setModalShow, modalData, setModalData, setIsSending } = useModal();
    const { searchInput, search } = useDebounceSearch({ placeholder: 'Rechercher par nom', delay: 400 });

    const [filteredCategories, setFilteredCategories] = useState(allCategories);

    useEffect(() => {
        setFilteredCategories(allCategories);
    }, [allCategories])

    useEffect(() => {
        if (allCategories) {
            setFilteredCategories([...allCategories.filter(
                category => HelperMetiers360.isSearchInText(search, category.name))
            ]);
        }
    }, [search, allCategories])

    const openCreateCategoriesModal = () => {
        const handleSubmit = () => {
            setIsSending(true);
            submitCategoryForm({ allCategories, action: createCategory })
                .then(() => {
                    toast.success();
                    setModalShow(false);
                })
                .finally(() => setIsSending(false));
        }

        setModalData({
            ...modalData,
            header: <>Création d'une catégorie client</>,
            content: <CategoriesFormComponent />,
            cancelButton: 'Annuler',
            onValidate: handleSubmit,
            size: 'xl',
        });
        setModalShow(true);
    };

    const createButton = categoriesSlugs?.create
        && <Button variant="success" onClick={() => { openCreateCategoriesModal() }} as="a" >
            <i className="fas fa-plus"></i> &nbsp;Nouvelle
        </Button>

    const isNoCategories = !isFetchingAllCategories && !allCategories.length
    const isNoResult = !isFetchingAllCategories && !!allCategories.length && !filteredCategories.length;

    return <>
        <Row className="item-page">
            <Col>
                {!isFetchingAllCategories && searchInput}
            </Col>
            <Col className="d-flex justify-content-end align-items-center">
                {createButton}
            </Col>
        </Row>

        {isFetchingAllCategories && allCategories.length < 1 && <Loader />}
        {filteredCategories.length > 0 && <CategoriesTableComponent categoriesToDisplay={filteredCategories} />}
        {isNoResult && <Alert className="mt-3" variant="warning"> Aucune catégorie client ne correspond à votre recherche</Alert>}
        {isNoCategories && <Alert className="mt-3" variant="warning">Vous n'avez accès à aucune catégorie client</Alert>}
        {modalComponent}
    </>;
}
export default CategoriesPage;